import React from "react";
import ReactDOM from "react-dom/client";
import "./design-system/tokens.css"; // tokens do DS (vars globais) — antes do resto
import "./index.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth"; // Importar o AuthProvider
import { CadastroAlunoProvider } from "./contexts/CadastroAlunoContext"; // Importar o CadastroAlunoProvider

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
      <AuthProvider>
        <CadastroAlunoProvider>
          {" "}
          {/* Envolver com CadastroAlunoProvider */}
          <App />
        </CadastroAlunoProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
